import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Tab = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  border: 1px solid ${props => props.selected ? '#bbbbbb' : '#dedfe0'};
  border-bottom-width: 0px;
  margin-right: 7px;
  text-align: center;
  padding: 5px 0px;
  background: ${props => props.selected ? 'white' : '#f5fbfc'};
  font-size: 12.5px;
  overflow-wrap: break-word;
  hyphens: auto;
  cursor: pointer;
  transition-property: height, width, flex-grow;
  transition-duration: 0.17s;
  transition-timing-function: ease;
  line-height: 1em;
  &:hover {
    background: white;
  }
  flex-grow: ${props => props.selected ? 1.05 : 1};
  flex-basis: auto;
  height: ${props => props.selected ? 120 : 100}%;
`
const TextContainer = styled.div`
  font-weight: ${props => props.selected ? 600 : 'normal'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
`
const Text = styled.div`
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  padding: 0px 5px;
  max-height: 4em;
  display: flex;
  justify-content: center;
  align-items: center;
`

const EntityTab = props => {
  const { entity, onClick, selected, id } = props
  const { name, title } = entity
  return (
    <Tab
      value={name}
      selected={selected}
      onClick={onClick}
      id={id}
    >
      <TextContainer selected={selected}>
        {title && <div>{title}{'\n'}</div>}
        <Text>{name}</Text>
      </TextContainer>
    </Tab>
  )
}

EntityTab.propTypes = {
  entity: PropTypes.shape({
    name: PropTypes.string,
    key: PropTypes.string,
    title: PropTypes.string
  }),
  id: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool
}

export default EntityTab